import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController, AlertController, NavParams, IonSearchbar, Platform } from '@ionic/angular';
import { CountryService } from './../../services/country.service';
import { Capacitor } from '@capacitor/core';

@Component({
    selector: 'app-country-picker',
    templateUrl: './country-picker.page.html',
    styleUrls: ['./country-picker.page.scss'],
})
export class CountryPickerPage implements OnInit {

    @ViewChild('search_bar_input', { static: false }) search_bar_input: IonSearchbar;

    params = {};
    all_countries = null;
    countries = null;
    keywords = null;
    visible_countries = null;
    modal_css_class = '';
    country = null;
    country_id = null;

    constructor(
        public navParams: NavParams,
        public modalController: ModalController,
        public alertController: AlertController,
        private countryService: CountryService,
        private platform: Platform
    ) { }

    ngOnInit() {

        if(this.navParams.get('country_id')) {
            this.country_id = this.navParams.get('country_id');
        }

        if(this.country_id && this.country_id.length) {
            this.countryService.getCountry(this.country_id).then((country) => {
                if(country) {
                    this.country = country;
                }
            })
            .catch(() => { });
        }

        this.countryService.getCountries().then((countries) => {
            if(countries) {
                this.all_countries = countries;
            }
        })
        .catch(() => { });

        if(Capacitor.isNativePlatform()) {
            this.modal_css_class = 'fullscreen';
        }

    }

    ionViewDidEnter() {
        // NOTE: we use a timeout here so the DOM gets a chance to load
        if(!this.country) {
            setTimeout(() => {
                if(this.search_bar_input) {
                    this.search_bar_input.setFocus();
                }
            }, 200);
        }
    }

    clear() {
        this.country_id = "";
        this.country = null;
        setTimeout(() => {
            if(this.search_bar_input) {
                this.search_bar_input.setFocus();
            }
        }, 200);
    }

    close() {
        if(this.country_id == "") {
            this.modalController.dismiss("country_deleted");
        }
        else {
            this.modalController.dismiss();
        }
    }

    select(country_id) {
        this.params["country_id"] = country_id;
        this.modalController.dismiss(this.params);
    }

    searchCountries() {
        let keywords = this.keywords.toLowerCase().trim();
        this.countries = null;
        this.visible_countries = null;
        if (keywords.length) {
            let countries = [];
            for (let i = 0; i < this.all_countries.length; i++) {
                if (
                    this.all_countries[i].title.toLowerCase().includes(keywords)
                ) {
                    countries.push(this.all_countries[i]);
                }
            }
            countries.sort((a, b) => {
                if (a['title'].toLowerCase() < b['title'].toLowerCase()) { return -1; }
                if (a['title'].toLowerCase() > b['title'].toLowerCase()) { return 1; }
                return 0;
            });
            this.countries = countries;
            this.showInitialVisibleCountries();
        }
    }

    showInitialVisibleCountries() {
        let promise = new Promise<void>((resolve, reject) => {
            this.visible_countries = [];
            for (let i = 0; i < 20; i++) {
                if (this.countries.length > i) {
                    this.visible_countries.push(this.countries[i]);
                } else {
                    break;
                }
            }
            resolve();
        });
        return promise;
    }

    showMoreVisibleCountries(event) {
        let count = this.visible_countries.length;
        for (let i = 0; i < 20; i++) {
            let position = i + count;
            if (this.countries.length > position) {
                this.visible_countries.push(this.countries[position]);
            } else {
                break;
            }
        }
        event.target.complete();
    }



}
